module.exports = "<div class=\"insert-variable-list\" (clickOutside)=\"toggleList(false)\">\n    <button type=\"button\" class=\"btn-link\" (click)=\"toggleList()\">Insert Subject Variable</button>\n    <ul *ngIf=\"openState\" class=\"dropdown-menu no-overflow\">\n        <li *ngFor=\"let variable of variableList\" (click)=\"chooseVariable(variable.key)\"><a>{{ variable.name }}</a></li>\n    </ul>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./shared/components/common/buttons/insert-variable/insert-variable.component.html
// module id = ./shared/components/common/buttons/insert-variable/insert-variable.component.html
// module chunks = 0